__turbopack_context__.v({
  "iconArrow": "InspirationLink-module__cReZgW__iconArrow",
  "image": "InspirationLink-module__cReZgW__image",
  "inspirationLink": "InspirationLink-module__cReZgW__inspirationLink",
  "text": "InspirationLink-module__cReZgW__text",
});
